export default "__VITE_ASSET__CTJffzb1__"